import Label from "components/atoms/forms/Label";
import { clsx } from "clsx";
import { UseFormRegister } from "react-hook-form";
import ErrorMessage from "../../atoms/forms/ErrorMessage";

type Props = {
  options: Array<Record<string, number | string>>;
  id: string;
  labelClasses?: string;
  additionalClasses?: string;
  errorMessage: string | undefined;
  label: string;
  isDisabled?: boolean;
  register: UseFormRegister<any>;
  isRequired?: boolean;
};

function PollSelectElement({
  options,
  id,
  labelClasses,
  additionalClasses,
  errorMessage,
  label,
  register,
  isDisabled,
  isRequired,
}: Props) {
  return (
    <div>
      <Label labelClasses={labelClasses} htmlFor={id} label={label} />
      <select
        disabled={isDisabled}
        id={id}
        className={clsx(
          "block w-full rounded-md border border-white bg-transparent p-4 font-450",
          "py-2  font-satoshi text-white placeholder-white placeholder:opacity-70",
          "h-14 focus:border-white focus:outline-none focus:ring-white",
          " disabled:cursor-not-allowed disabled:bg-white disabled:opacity-50",
          additionalClasses,
        )}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...register(id, {
          required: isRequired,
        })}
      >
        {options.map((option) => (
          // eslint-disable-next-line react/no-array-index-key
          <option className="bg-primary" value={option.value} key={`options-${option.key}`}>
            {option.key}
          </option>
        ))}
      </select>
      <ErrorMessage errorMessage={errorMessage} />
    </div>
  );
}
export default PollSelectElement;
